import { UsersService } from '../../shared/services/users.service';
import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientsService } from '../../shared/services/clients.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from '../../shared/services/notifications.service';
import { ConfirmationDialogService } from '../../shared/confirmation-dialog/confirmation-dialog.service';

@Component({
    selector: 'app-users-page',
    templateUrl: './users-page.component.html',
    styleUrls: ['./users-page.component.css']

})
export class UsersPageComponent implements OnInit, OnDestroy {

    public items;
    public itemsCount;

    private allClients;
    private clients;
    public selectedClient;
    public selectedSite;

    @ViewChild("content", { static: false })
    private modal: TemplateRef<any>;
    public modalFormModel;

    @ViewChild("modalResetPassword", { static: false })
    private modalResetPassword: TemplateRef<any>;
    public resetPasswordFormModel;

    public filterFormModel = { page: 1, pageSize: 10, role: -1, name: "" };

    constructor(
        private usersService: UsersService,
        private clientsService: ClientsService,
        private modalService: NgbModal,
        private spinner: NgxSpinnerService,
        private notifications: NotificationsService,
        private confirmationDialogService: ConfirmationDialogService) {
    }

    ngOnInit() {
        this.list();
        this.clientsService.listAll().subscribe(response => {
            this.allClients = response;
        });
    };

    ngOnDestroy() {
        this.modalService.dismissAll();
    };

    listPage(page: number) {
        this.filterFormModel.page = page;
        this.list();
    };

    list() {
        this.spinner.show();
        this.usersService.list(this.filterFormModel).subscribe(response => {
            // this.items = response.data;
            this.items = response.data.map(u => {
                if (u.dateLastLogin) {
                    // transforma "20250805" → "2025-08-05"
                    u.dateLastLogin = u.dateLastLogin.replace(/(\d{4})(\d{2})(\d{2})/, "$3/$2/$1");

                }
                return u;
            });

            this.itemsCount = response.count;


            this.spinner.hide();
        });

    };

    clearFilter() {
        this.filterFormModel.role = -1;
        this.filterFormModel.name = "";
        this.list();
    };

    create() {
        this.modalFormModel = {
            role: "0",
            active: "true",
            sitePermissions: []
        };
        delete this.selectedClient;
        delete this.selectedSite;
        this.listClients([]);
        this.modalService.open(this.modal, { size: 'lg', backdrop: 'static', keyboard: false });
    };

    update(post) {
        this.spinner.show();
        this.usersService.get(post.id).subscribe(response => {
            this.modalFormModel = response;
            this.modalFormModel.source = post;
            this.modalFormModel.role = response.role.toString();

            delete this.selectedClient;
            delete this.selectedSite;
            this.listClients(this.modalFormModel.sitePermissions);
            this.modalService.open(this.modal, { size: 'lg', backdrop: 'static', keyboard: false });
            this.spinner.hide();
        });
    };

    submitModalFormModel(form) {
        if (!form.valid) {
            Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
            return;
        }

        if (this.modalFormModel.id && !form.dirty) {
            this.modalService.dismissAll();
            return;
        }

        if ((this.modalFormModel.role == "1" || this.modalFormModel.role == "2") && this.modalFormModel.sitePermissions.length == 0) {
            return;
        }

        let requestModel = Object.assign({}, this.modalFormModel);
        requestModel.sitePermissions = requestModel.sitePermissions.map((item: any) => { return { id: item.id, idSite: item.site.id } });

        let outerThis = this;
        let callback = function (response) {
            outerThis.spinner.hide();
            if (!response.success) {
                outerThis.notifications.errors(response.payload.messages);
                return;
            }
            outerThis.notifications.success(!outerThis.modalFormModel.id ? 'Cadastro de novo usuário realizado com sucesso.' : 'Dados do usuário atualizados com sucesso.');
            outerThis.modalService.dismissAll();
            outerThis.list();
        };

        if (requestModel.id) {
            this.spinner.show();
            this.usersService.update(requestModel).subscribe(callback);
        } else {
            this.spinner.show();
            this.usersService.create(requestModel).subscribe(callback);
        }
    };

    closeModalFormModel(form) {
        if (!form.dirty) {
            this.modalService.dismissAll();
            return;
        }

        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) {
                return;
            }
            outherThis.modalService.dismissAll();
        };

        this.confirmationDialogService.confirm('Tem certeza de que deseja cancelar as alterações realizadas ?', "Sim", "Não").then(confirmedCallback);
    };

    delete(post) {
        let outherThis = this;
        let confirmedCallback = function (confirmed) {
            if (!confirmed) {
                return;
            }
            outherThis.spinner.show();
            outherThis.usersService.delete(post).subscribe(response => {
                outherThis.spinner.hide();
                if (!response.success) {
                    outherThis.notifications.errors(response.payload.messages);
                    return;
                }
                outherThis.notifications.success('Cadastro de usuário removido com sucesso.');
                outherThis.list();
            });
        };

        this.confirmationDialogService.confirm('Tem certeza de que deseja remover este usuário ?').then(confirmedCallback);
    };

    resetPassword(item) {
        this.resetPasswordFormModel = {
            id: item.id,
            user: item
        };
        this.modalService.open(this.modalResetPassword, { size: 'lg', backdrop: 'static', keyboard: false });
    };

    submitResetPasswordFormModel() {
        this.spinner.show();
        this.usersService.resetPassword(this.resetPasswordFormModel).subscribe(response => {
            this.spinner.hide();
            if (!response.success) {
                this.notifications.errors(response.payload.messages);
                return;
            }
            this.notifications.success('Nova senha gerada com sucesso.');
            this.modalService.dismissAll();
        });
    };

    addSitePermission(form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());

        let outherThis = this;
        let doAdd = function () {
            outherThis.selectedSite.client = outherThis.selectedClient;
            outherThis.modalFormModel.sitePermissions.push({
                site: outherThis.selectedSite
            });

            outherThis.listClients(outherThis.modalFormModel.sitePermissions);
        };

        // se não é do tipo cliente, adiciona permissao a site
        if (this.modalFormModel.role != '2') {
            doAdd();
            return;
        }

        if (this.modalFormModel.sitePermissions.filter(p => p.site.client.id != this.selectedClient.id).length == 0) {
            doAdd();
            return;
        }

        // se é usuário do tipo site
        this.confirmationDialogService.confirm('Este usuário já está associado a sites de outro cliente. Deseja fazer a troca ?', "Sim", "Não", "sm").then(function (confirmed) {
            if (!confirmed) {
                return;
            }
            outherThis.modalFormModel.sitePermissions = [];
            doAdd();
        });
    };

    removeSitePermission(permission, form) {
        Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
        this.modalFormModel.sitePermissions.splice(this.modalFormModel.sitePermissions.indexOf(permission), 1);
        this.listClients(this.modalFormModel.sitePermissions);
    };

    listClients(permissions) {
        this.clients = [];

        for (let i in this.allClients) {
            if (!this.allClients[i].active) continue;

            let client = Object.assign({}, this.allClients[i]);
            client.sites = [];
            for (var k in this.allClients[i].sites) {
                if (!this.allClients[i].sites[k].active) continue;
                // verifica se já não tem permissão para este site (se tiver, não lista)
                if (permissions.filter(p => (p.site.id == this.allClients[i].sites[k].id)).length > 0) {
                    continue;
                }
                client.sites.push(this.allClients[i].sites[k]);
            }
            if (client.sites.length > 0) this.clients.push(client);
        }

        if (this.clients.length > 0) {
            if (this.selectedClient) {
                this.selectedClient = this.clients.filter(p => p.id == (this.selectedClient.id)).length > 0 ? this.clients.filter(p => p.id == (this.selectedClient.id))[0] : this.clients[0];
            } else {
                this.selectedClient = this.clients[0];
            }
            this.selectedSite = this.selectedClient.sites[0];
        } else {
            delete this.selectedClient;
            delete this.selectedSite;
        }
    };

    selectedClientChanged() {
        this.selectedSite = this.selectedClient.sites[0];
    };
}
